export const SET_USER = "SET_USER";
export const SET_OSS = "SET_OSS";
export const SET_STATE = "SET_STATE";
export const CLEAN_USER = "CLEAN_ALL";
export const regionWidthChangedNum = "regionWidthChangedNum";
export const SET_IS_MIGRATORY = "SET_IS_MIGRATORY";



// WEBPACK FOOTER //
// ./src/store/mutations-vars.js